module.exports = __webpack_public_path__ + "img/cart.90f033ad.svg";